import { loadGroupList } from '../api/group.api';
import { loadActivitiesList } from '../api/activity.api';
export class DataLoader {
    constructor(dataProvider) {
        this._groups = [];
        this._activities = [];
        this._dataProvider = dataProvider;
    }
    async load() {
        const [groups, activities] = await Promise.all([
            loadGroupList(this._dataProvider.branchId),
            loadActivitiesList(this._dataProvider.branchId)
        ]);
        this._groups = groups.seznam;
        this._activities = activities.seznam;
    }
    get groups() {
        return this._groups;
    }
    get activities() {
        return this._activities;
    }
}
